(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("vue"));
	else if(typeof define === 'function' && define.amd)
		define("BaklavaJSOptionsVue", ["vue"], factory);
	else if(typeof exports === 'object')
		exports["BaklavaJSOptionsVue"] = factory(require("vue"));
	else
		root["BaklavaJSOptionsVue"] = factory(root["Vue"]);
})((typeof self !== 'undefined' ? self : this), function(__WEBPACK_EXTERNAL_MODULE__22__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 48);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __extends; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __assign; });
/* unused harmony export __rest */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __decorate; });
/* unused harmony export __param */
/* unused harmony export __metadata */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __awaiter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __generator; });
/* unused harmony export __exportStar */
/* unused harmony export __values */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __read; });
/* unused harmony export __spread */
/* unused harmony export __await */
/* unused harmony export __asyncGenerator */
/* unused harmony export __asyncDelegator */
/* unused harmony export __asyncValues */
/* unused harmony export __makeTemplateObject */
/* unused harmony export __importStar */
/* unused harmony export __importDefault */
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    }
    return __assign.apply(this, arguments);
}

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
}

function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __param(paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
}

function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

function __awaiter(thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __exportStar(m, exports) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}

function __values(o) {
    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
    if (m) return m.call(o);
    return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}

function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}

function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
    function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
    function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
    function fulfill(value) { resume("next", value); }
    function reject(value) { resume("throw", value); }
    function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
}

function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
    function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v; } : f; }
}

function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
}

function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};

function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result.default = mod;
    return result;
}

function __importDefault(mod) {
    return (mod && mod.__esModule) ? mod : { default: mod };
}


/***/ }),
/* 1 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Inject */
/* unused harmony export Provide */
/* unused harmony export Model */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Prop; });
/* unused harmony export Watch */
/* unused harmony export Emit */
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(22);
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_0__);
/* harmony reexport (default from non-harmony) */ __webpack_require__.d(__webpack_exports__, "c", function() { return vue__WEBPACK_IMPORTED_MODULE_0___default.a; });
/* harmony import */ var vue_class_component__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3);
/* harmony import */ var vue_class_component__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(vue_class_component__WEBPACK_IMPORTED_MODULE_1__);
/* harmony reexport (default from non-harmony) */ __webpack_require__.d(__webpack_exports__, "a", function() { return vue_class_component__WEBPACK_IMPORTED_MODULE_1___default.a; });
/** vue-property-decorator verson 8.1.0 MIT LICENSE copyright 2018 kaorun343 */
/// <reference types='reflect-metadata'/>




/**
 * decorator of an inject
 * @param from key
 * @return PropertyDecorator
 */
function Inject(options) {
    return Object(vue_class_component__WEBPACK_IMPORTED_MODULE_1__["createDecorator"])(function (componentOptions, key) {
        if (typeof componentOptions.inject === 'undefined') {
            componentOptions.inject = {};
        }
        if (!Array.isArray(componentOptions.inject)) {
            componentOptions.inject[key] = options || key;
        }
    });
}
/**
 * decorator of a provide
 * @param key key
 * @return PropertyDecorator | void
 */
function Provide(key) {
    return Object(vue_class_component__WEBPACK_IMPORTED_MODULE_1__["createDecorator"])(function (componentOptions, k) {
        var provide = componentOptions.provide;
        if (typeof provide !== 'function' || !provide.managed) {
            var original_1 = componentOptions.provide;
            provide = componentOptions.provide = function () {
                var rv = Object.create((typeof original_1 === 'function' ? original_1.call(this) : original_1) || null);
                for (var i in provide.managed)
                    rv[provide.managed[i]] = this[i];
                return rv;
            };
            provide.managed = {};
        }
        provide.managed[k] = key || k;
    });
}
/** @see {@link https://github.com/vuejs/vue-class-component/blob/master/src/reflect.ts} */
var reflectMetadataIsSupported = typeof Reflect !== 'undefined' && typeof Reflect.getMetadata !== 'undefined';
function applyMetadata(options, target, key) {
    if (reflectMetadataIsSupported) {
        if (!Array.isArray(options) && typeof options !== 'function' && typeof options.type === 'undefined') {
            options.type = Reflect.getMetadata('design:type', target, key);
        }
    }
}
/**
 * decorator of model
 * @param  event event name
 * @param options options
 * @return PropertyDecorator
 */
function Model(event, options) {
    if (options === void 0) { options = {}; }
    return function (target, key) {
        applyMetadata(options, target, key);
        Object(vue_class_component__WEBPACK_IMPORTED_MODULE_1__["createDecorator"])(function (componentOptions, k) {
            (componentOptions.props || (componentOptions.props = {}))[k] = options;
            componentOptions.model = { prop: k, event: event || k };
        })(target, key);
    };
}
/**
 * decorator of a prop
 * @param  options the options for the prop
 * @return PropertyDecorator | void
 */
function Prop(options) {
    if (options === void 0) { options = {}; }
    return function (target, key) {
        applyMetadata(options, target, key);
        Object(vue_class_component__WEBPACK_IMPORTED_MODULE_1__["createDecorator"])(function (componentOptions, k) {
            (componentOptions.props || (componentOptions.props = {}))[k] = options;
        })(target, key);
    };
}
/**
 * decorator of a watch function
 * @param  path the path or the expression to observe
 * @param  WatchOption
 * @return MethodDecorator
 */
function Watch(path, options) {
    if (options === void 0) { options = {}; }
    var _a = options.deep, deep = _a === void 0 ? false : _a, _b = options.immediate, immediate = _b === void 0 ? false : _b;
    return Object(vue_class_component__WEBPACK_IMPORTED_MODULE_1__["createDecorator"])(function (componentOptions, handler) {
        if (typeof componentOptions.watch !== 'object') {
            componentOptions.watch = Object.create(null);
        }
        var watch = componentOptions.watch;
        if (typeof watch[path] === 'object' && !Array.isArray(watch[path])) {
            watch[path] = [watch[path]];
        }
        else if (typeof watch[path] === 'undefined') {
            watch[path] = [];
        }
        watch[path].push({ handler: handler, deep: deep, immediate: immediate });
    });
}
// Code copied from Vue/src/shared/util.js
var hyphenateRE = /\B([A-Z])/g;
var hyphenate = function (str) { return str.replace(hyphenateRE, '-$1').toLowerCase(); };
/**
 * decorator of an event-emitter function
 * @param  event The name of the event
 * @return MethodDecorator
 */
function Emit(event) {
    return function (_target, key, descriptor) {
        key = hyphenate(key);
        var original = descriptor.value;
        descriptor.value = function emitter() {
            var _this = this;
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            var emit = function (returnValue) {
                if (returnValue !== undefined)
                    args.unshift(returnValue);
                _this.$emit.apply(_this, [event || key].concat(args));
            };
            var returnValue = original.apply(this, args);
            if (isPromise(returnValue)) {
                returnValue.then(function (returnValue) {
                    emit(returnValue);
                });
            }
            else {
                emit(returnValue);
            }
        };
    };
}
function isPromise(obj) {
    return obj instanceof Promise || (obj && typeof obj.then === 'function');
}


/***/ }),
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return normalizeComponent; });
/* globals __VUE_SSR_CONTEXT__ */

// IMPORTANT: Do NOT use ES2015 features in this file (except for modules).
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

function normalizeComponent (
  scriptExports,
  render,
  staticRenderFns,
  functionalTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier, /* server only */
  shadowMode /* vue-cli only */
) {
  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (render) {
    options.render = render
    options.staticRenderFns = staticRenderFns
    options._compiled = true
  }

  // functional template
  if (functionalTemplate) {
    options.functional = true
  }

  // scopedId
  if (scopeId) {
    options._scopeId = 'data-v-' + scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = shadowMode
      ? function () { injectStyles.call(this, this.$root.$options.shadowRoot) }
      : injectStyles
  }

  if (hook) {
    if (options.functional) {
      // for template-only hot-reload because in that case the render fn doesn't
      // go through the normalizer
      options._injectStyles = hook
      // register for functioal component in vue file
      var originalRender = options.render
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return originalRender(h, context)
      }
    } else {
      // inject component registration as beforeCreate hook
      var existing = options.beforeCreate
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    }
  }

  return {
    exports: scriptExports,
    options: options
  }
}


/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
  * vue-class-component v7.0.2
  * (c) 2015-present Evan You
  * @license MIT
  */


Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var Vue = _interopDefault(__webpack_require__(22));

// The rational behind the verbose Reflect-feature check below is the fact that there are polyfills
// which add an implementation for Reflect.defineMetadata but not for Reflect.getOwnMetadataKeys.
// Without this check consumers will encounter hard to track down runtime errors.
var reflectionIsSupported = typeof Reflect !== 'undefined' && Reflect.defineMetadata && Reflect.getOwnMetadataKeys;
function copyReflectionMetadata(to, from) {
    forwardMetadata(to, from);
    Object.getOwnPropertyNames(from.prototype).forEach(function (key) {
        forwardMetadata(to.prototype, from.prototype, key);
    });
    Object.getOwnPropertyNames(from).forEach(function (key) {
        forwardMetadata(to, from, key);
    });
}
function forwardMetadata(to, from, propertyKey) {
    var metaKeys = propertyKey
        ? Reflect.getOwnMetadataKeys(from, propertyKey)
        : Reflect.getOwnMetadataKeys(from);
    metaKeys.forEach(function (metaKey) {
        var metadata = propertyKey
            ? Reflect.getOwnMetadata(metaKey, from, propertyKey)
            : Reflect.getOwnMetadata(metaKey, from);
        if (propertyKey) {
            Reflect.defineMetadata(metaKey, metadata, to, propertyKey);
        }
        else {
            Reflect.defineMetadata(metaKey, metadata, to);
        }
    });
}

var fakeArray = { __proto__: [] };
var hasProto = fakeArray instanceof Array;
function createDecorator(factory) {
    return function (target, key, index) {
        var Ctor = typeof target === 'function'
            ? target
            : target.constructor;
        if (!Ctor.__decorators__) {
            Ctor.__decorators__ = [];
        }
        if (typeof index !== 'number') {
            index = undefined;
        }
        Ctor.__decorators__.push(function (options) { return factory(options, key, index); });
    };
}
function mixins() {
    var Ctors = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        Ctors[_i] = arguments[_i];
    }
    return Vue.extend({ mixins: Ctors });
}
function isPrimitive(value) {
    var type = typeof value;
    return value == null || (type !== 'object' && type !== 'function');
}
function warn(message) {
    if (typeof console !== 'undefined') {
        console.warn('[vue-class-component] ' + message);
    }
}

function collectDataFromConstructor(vm, Component) {
    // override _init to prevent to init as Vue instance
    var originalInit = Component.prototype._init;
    Component.prototype._init = function () {
        var _this = this;
        // proxy to actual vm
        var keys = Object.getOwnPropertyNames(vm);
        // 2.2.0 compat (props are no longer exposed as self properties)
        if (vm.$options.props) {
            for (var key in vm.$options.props) {
                if (!vm.hasOwnProperty(key)) {
                    keys.push(key);
                }
            }
        }
        keys.forEach(function (key) {
            if (key.charAt(0) !== '_') {
                Object.defineProperty(_this, key, {
                    get: function () { return vm[key]; },
                    set: function (value) { vm[key] = value; },
                    configurable: true
                });
            }
        });
    };
    // should be acquired class property values
    var data = new Component();
    // restore original _init to avoid memory leak (#209)
    Component.prototype._init = originalInit;
    // create plain data object
    var plainData = {};
    Object.keys(data).forEach(function (key) {
        if (data[key] !== undefined) {
            plainData[key] = data[key];
        }
    });
    if (false) {}
    return plainData;
}

var $internalHooks = [
    'data',
    'beforeCreate',
    'created',
    'beforeMount',
    'mounted',
    'beforeDestroy',
    'destroyed',
    'beforeUpdate',
    'updated',
    'activated',
    'deactivated',
    'render',
    'errorCaptured',
    'serverPrefetch' // 2.6
];
function componentFactory(Component, options) {
    if (options === void 0) { options = {}; }
    options.name = options.name || Component._componentTag || Component.name;
    // prototype props.
    var proto = Component.prototype;
    Object.getOwnPropertyNames(proto).forEach(function (key) {
        if (key === 'constructor') {
            return;
        }
        // hooks
        if ($internalHooks.indexOf(key) > -1) {
            options[key] = proto[key];
            return;
        }
        var descriptor = Object.getOwnPropertyDescriptor(proto, key);
        if (descriptor.value !== void 0) {
            // methods
            if (typeof descriptor.value === 'function') {
                (options.methods || (options.methods = {}))[key] = descriptor.value;
            }
            else {
                // typescript decorated data
                (options.mixins || (options.mixins = [])).push({
                    data: function () {
                        var _a;
                        return _a = {}, _a[key] = descriptor.value, _a;
                    }
                });
            }
        }
        else if (descriptor.get || descriptor.set) {
            // computed properties
            (options.computed || (options.computed = {}))[key] = {
                get: descriptor.get,
                set: descriptor.set
            };
        }
    });
    (options.mixins || (options.mixins = [])).push({
        data: function () {
            return collectDataFromConstructor(this, Component);
        }
    });
    // decorate options
    var decorators = Component.__decorators__;
    if (decorators) {
        decorators.forEach(function (fn) { return fn(options); });
        delete Component.__decorators__;
    }
    // find super
    var superProto = Object.getPrototypeOf(Component.prototype);
    var Super = superProto instanceof Vue
        ? superProto.constructor
        : Vue;
    var Extended = Super.extend(options);
    forwardStaticMembers(Extended, Component, Super);
    if (reflectionIsSupported) {
        copyReflectionMetadata(Extended, Component);
    }
    return Extended;
}
var reservedPropertyNames = [
    // Unique id
    'cid',
    // Super Vue constructor
    'super',
    // Component options that will be used by the component
    'options',
    'superOptions',
    'extendOptions',
    'sealedOptions',
    // Private assets
    'component',
    'directive',
    'filter'
];
var shouldIgnore = {
    prototype: true,
    arguments: true,
    callee: true,
    caller: true
};
function forwardStaticMembers(Extended, Original, Super) {
    // We have to use getOwnPropertyNames since Babel registers methods as non-enumerable
    Object.getOwnPropertyNames(Original).forEach(function (key) {
        // Skip the properties that should not be overwritten
        if (shouldIgnore[key]) {
            return;
        }
        // Some browsers does not allow reconfigure built-in properties
        var extendedDescriptor = Object.getOwnPropertyDescriptor(Extended, key);
        if (extendedDescriptor && !extendedDescriptor.configurable) {
            return;
        }
        var descriptor = Object.getOwnPropertyDescriptor(Original, key);
        // If the user agent does not support `__proto__` or its family (IE <= 10),
        // the sub class properties may be inherited properties from the super class in TypeScript.
        // We need to exclude such properties to prevent to overwrite
        // the component options object which stored on the extended constructor (See #192).
        // If the value is a referenced value (object or function),
        // we can check equality of them and exclude it if they have the same reference.
        // If it is a primitive value, it will be forwarded for safety.
        if (!hasProto) {
            // Only `cid` is explicitly exluded from property forwarding
            // because we cannot detect whether it is a inherited property or not
            // on the no `__proto__` environment even though the property is reserved.
            if (key === 'cid') {
                return;
            }
            var superDescriptor = Object.getOwnPropertyDescriptor(Super, key);
            if (!isPrimitive(descriptor.value) &&
                superDescriptor &&
                superDescriptor.value === descriptor.value) {
                return;
            }
        }
        // Warn if the users manually declare reserved properties
        if (false) {}
        Object.defineProperty(Extended, key, descriptor);
    });
}

function Component(options) {
    if (typeof options === 'function') {
        return componentFactory(options);
    }
    return function (Component) {
        return componentFactory(Component, options);
    };
}
Component.registerHooks = function registerHooks(keys) {
    $internalHooks.push.apply($internalHooks, keys);
};

exports.default = Component;
exports.createDecorator = createDecorator;
exports.mixins = mixins;


/***/ }),
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _Arrow_vue_vue_type_template_id_d85cb940___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27);
/* harmony import */ var _Arrow_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(14);
/* harmony import */ var _node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2);





/* normalize component */

var component = Object(_node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"])(
  _Arrow_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"],
  _Arrow_vue_vue_type_template_id_d85cb940___WEBPACK_IMPORTED_MODULE_0__[/* render */ "a"],
  _Arrow_vue_vue_type_template_id_d85cb940___WEBPACK_IMPORTED_MODULE_0__[/* staticRenderFns */ "b"],
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (false) { var api; }
component.options.__file = "src/Arrow.vue"
/* harmony default export */ __webpack_exports__["a"] = (component.exports);

/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _ButtonOption_vue__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(31);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ButtonOption", function() { return _ButtonOption_vue__WEBPACK_IMPORTED_MODULE_0__["a"]; });

/* harmony import */ var _CheckboxOption_vue__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(33);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "CheckboxOption", function() { return _CheckboxOption_vue__WEBPACK_IMPORTED_MODULE_1__["a"]; });

/* harmony import */ var _InputOption_vue__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(35);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "InputOption", function() { return _InputOption_vue__WEBPACK_IMPORTED_MODULE_2__["a"]; });

/* harmony import */ var _IntegerOption_vue__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(37);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "IntegerOption", function() { return _IntegerOption_vue__WEBPACK_IMPORTED_MODULE_3__["a"]; });

/* harmony import */ var _NumberOption_vue__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(40);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "NumberOption", function() { return _NumberOption_vue__WEBPACK_IMPORTED_MODULE_4__["a"]; });

/* harmony import */ var _SelectOption_vue__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(42);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SelectOption", function() { return _SelectOption_vue__WEBPACK_IMPORTED_MODULE_5__["a"]; });

/* harmony import */ var _TextOption_vue__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(44);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "TextOption", function() { return _TextOption_vue__WEBPACK_IMPORTED_MODULE_6__["a"]; });











/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_ts_loader_index_js_ref_0_node_modules_vue_loader_lib_index_js_vue_loader_options_ButtonOption_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7);
 /* harmony default export */ __webpack_exports__["a"] = (_node_modules_ts_loader_index_js_ref_0_node_modules_vue_loader_lib_index_js_vue_loader_options_ButtonOption_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"]); 

/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(0);
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1);


var ButtonOption = /** @class */ (function (_super) {
    tslib__WEBPACK_IMPORTED_MODULE_0__[/* __extends */ "d"](ButtonOption, _super);
    function ButtonOption() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    tslib__WEBPACK_IMPORTED_MODULE_0__[/* __decorate */ "c"]([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_1__[/* Prop */ "b"])({ type: String })
    ], ButtonOption.prototype, "name", void 0);
    ButtonOption = tslib__WEBPACK_IMPORTED_MODULE_0__[/* __decorate */ "c"]([
        vue_property_decorator__WEBPACK_IMPORTED_MODULE_1__[/* Component */ "a"]
    ], ButtonOption);
    return ButtonOption;
}(vue_property_decorator__WEBPACK_IMPORTED_MODULE_1__[/* Vue */ "c"]));
/* harmony default export */ __webpack_exports__["a"] = (ButtonOption);


/***/ }),
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_ts_loader_index_js_ref_0_node_modules_vue_loader_lib_index_js_vue_loader_options_CheckboxOption_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9);
 /* harmony default export */ __webpack_exports__["a"] = (_node_modules_ts_loader_index_js_ref_0_node_modules_vue_loader_lib_index_js_vue_loader_options_CheckboxOption_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"]); 

/***/ }),
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(0);
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1);


var InputOption = /** @class */ (function (_super) {
    tslib__WEBPACK_IMPORTED_MODULE_0__[/* __extends */ "d"](InputOption, _super);
    function InputOption() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    tslib__WEBPACK_IMPORTED_MODULE_0__[/* __decorate */ "c"]([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_1__[/* Prop */ "b"])({ type: Boolean })
    ], InputOption.prototype, "value", void 0);
    tslib__WEBPACK_IMPORTED_MODULE_0__[/* __decorate */ "c"]([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_1__[/* Prop */ "b"])({ type: String })
    ], InputOption.prototype, "name", void 0);
    InputOption = tslib__WEBPACK_IMPORTED_MODULE_0__[/* __decorate */ "c"]([
        vue_property_decorator__WEBPACK_IMPORTED_MODULE_1__[/* Component */ "a"]
    ], InputOption);
    return InputOption;
}(vue_property_decorator__WEBPACK_IMPORTED_MODULE_1__[/* Vue */ "c"]));
/* harmony default export */ __webpack_exports__["a"] = (InputOption);


/***/ }),
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_ts_loader_index_js_ref_0_node_modules_vue_loader_lib_index_js_vue_loader_options_InputOption_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11);
 /* harmony default export */ __webpack_exports__["a"] = (_node_modules_ts_loader_index_js_ref_0_node_modules_vue_loader_lib_index_js_vue_loader_options_InputOption_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"]); 

/***/ }),
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(0);
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1);


var InputOption = /** @class */ (function (_super) {
    tslib__WEBPACK_IMPORTED_MODULE_0__[/* __extends */ "d"](InputOption, _super);
    function InputOption() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(InputOption.prototype, "listeners", {
        get: function () {
            var _this = this;
            return tslib__WEBPACK_IMPORTED_MODULE_0__[/* __assign */ "a"]({}, this.$listeners, { input: function (ev) { return _this.$emit("input", ev.target.value); } });
        },
        enumerable: true,
        configurable: true
    });
    tslib__WEBPACK_IMPORTED_MODULE_0__[/* __decorate */ "c"]([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_1__[/* Prop */ "b"])({ type: String, default: "" })
    ], InputOption.prototype, "value", void 0);
    tslib__WEBPACK_IMPORTED_MODULE_0__[/* __decorate */ "c"]([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_1__[/* Prop */ "b"])({ type: String })
    ], InputOption.prototype, "name", void 0);
    InputOption = tslib__WEBPACK_IMPORTED_MODULE_0__[/* __decorate */ "c"]([
        vue_property_decorator__WEBPACK_IMPORTED_MODULE_1__[/* Component */ "a"]
    ], InputOption);
    return InputOption;
}(vue_property_decorator__WEBPACK_IMPORTED_MODULE_1__[/* Vue */ "c"]));
/* harmony default export */ __webpack_exports__["a"] = (InputOption);


/***/ }),
/* 12 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_ts_loader_index_js_ref_0_node_modules_vue_loader_lib_index_js_vue_loader_options_IntegerOption_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13);
 /* harmony default export */ __webpack_exports__["a"] = (_node_modules_ts_loader_index_js_ref_0_node_modules_vue_loader_lib_index_js_vue_loader_options_IntegerOption_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"]); 

/***/ }),
/* 13 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(0);
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1);
/* harmony import */ var _Arrow_vue__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4);



var IntegerOption = /** @class */ (function (_super) {
    tslib__WEBPACK_IMPORTED_MODULE_0__[/* __extends */ "d"](IntegerOption, _super);
    function IntegerOption() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.MAX_STRING_LENGTH = 9;
        _this.editMode = false;
        _this.tempValue = "0";
        return _this;
    }
    Object.defineProperty(IntegerOption.prototype, "v", {
        get: function () {
            if (typeof (this.value) === "string") {
                return parseInt(this.value, 10);
            }
            else if (typeof (this.value) === "number") {
                return Math.floor(this.value);
            }
            else {
                return 0;
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IntegerOption.prototype, "stringRepresentation", {
        get: function () {
            var s = this.v.toString();
            return s.length > this.MAX_STRING_LENGTH ?
                this.v.toExponential(this.MAX_STRING_LENGTH - 5) :
                s;
        },
        enumerable: true,
        configurable: true
    });
    IntegerOption.prototype.increment = function () {
        this.$emit("input", this.v + 1);
    };
    IntegerOption.prototype.decrement = function () {
        this.$emit("input", this.v - 1);
    };
    IntegerOption.prototype.enterEditMode = function () {
        return tslib__WEBPACK_IMPORTED_MODULE_0__[/* __awaiter */ "b"](this, void 0, void 0, function () {
            return tslib__WEBPACK_IMPORTED_MODULE_0__[/* __generator */ "e"](this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.tempValue = this.v.toString();
                        this.editMode = true;
                        return [4 /*yield*/, this.$nextTick()];
                    case 1:
                        _a.sent();
                        this.$refs.input.focus();
                        return [2 /*return*/];
                }
            });
        });
    };
    IntegerOption.prototype.leaveEditMode = function () {
        this.$emit("input", parseInt(this.tempValue, 10));
        this.editMode = false;
    };
    tslib__WEBPACK_IMPORTED_MODULE_0__[/* __decorate */ "c"]([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_1__[/* Prop */ "b"])()
    ], IntegerOption.prototype, "value", void 0);
    tslib__WEBPACK_IMPORTED_MODULE_0__[/* __decorate */ "c"]([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_1__[/* Prop */ "b"])({ type: String })
    ], IntegerOption.prototype, "name", void 0);
    IntegerOption = tslib__WEBPACK_IMPORTED_MODULE_0__[/* __decorate */ "c"]([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_1__[/* Component */ "a"])({
            components: {
                "i-arrow": _Arrow_vue__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"]
            }
        })
    ], IntegerOption);
    return IntegerOption;
}(vue_property_decorator__WEBPACK_IMPORTED_MODULE_1__[/* Vue */ "c"]));
/* harmony default export */ __webpack_exports__["a"] = (IntegerOption);


/***/ }),
/* 14 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_ts_loader_index_js_ref_0_node_modules_vue_loader_lib_index_js_vue_loader_options_Arrow_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(15);
 /* harmony default export */ __webpack_exports__["a"] = (_node_modules_ts_loader_index_js_ref_0_node_modules_vue_loader_lib_index_js_vue_loader_options_Arrow_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"]); 

/***/ }),
/* 15 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(0);
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1);


var Arrow = /** @class */ (function (_super) {
    tslib__WEBPACK_IMPORTED_MODULE_0__[/* __extends */ "d"](Arrow, _super);
    function Arrow() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Arrow = tslib__WEBPACK_IMPORTED_MODULE_0__[/* __decorate */ "c"]([
        vue_property_decorator__WEBPACK_IMPORTED_MODULE_1__[/* Component */ "a"]
    ], Arrow);
    return Arrow;
}(vue_property_decorator__WEBPACK_IMPORTED_MODULE_1__[/* Vue */ "c"]));
/* harmony default export */ __webpack_exports__["a"] = (Arrow);


/***/ }),
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_ts_loader_index_js_ref_0_node_modules_vue_loader_lib_index_js_vue_loader_options_NumberOption_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(17);
 /* harmony default export */ __webpack_exports__["a"] = (_node_modules_ts_loader_index_js_ref_0_node_modules_vue_loader_lib_index_js_vue_loader_options_NumberOption_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"]); 

/***/ }),
/* 17 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(0);
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1);
/* harmony import */ var _Arrow_vue__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4);



var NumberOption = /** @class */ (function (_super) {
    tslib__WEBPACK_IMPORTED_MODULE_0__[/* __extends */ "d"](NumberOption, _super);
    function NumberOption() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.MAX_STRING_LENGTH = 9;
        _this.editMode = false;
        _this.tempValue = "0";
        return _this;
    }
    Object.defineProperty(NumberOption.prototype, "v", {
        get: function () {
            if (typeof (this.value) === "string") {
                return parseFloat(this.value);
            }
            else if (typeof (this.value) === "number") {
                return this.value;
            }
            else {
                return 0;
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NumberOption.prototype, "stringRepresentation", {
        get: function () {
            var s = this.v.toFixed(3);
            return s.length > this.MAX_STRING_LENGTH ?
                this.v.toExponential(this.MAX_STRING_LENGTH - 5) :
                s;
        },
        enumerable: true,
        configurable: true
    });
    NumberOption.prototype.increment = function () {
        this.$emit("input", this.v + 0.1);
    };
    NumberOption.prototype.decrement = function () {
        this.$emit("input", this.v - 0.1);
    };
    NumberOption.prototype.enterEditMode = function () {
        return tslib__WEBPACK_IMPORTED_MODULE_0__[/* __awaiter */ "b"](this, void 0, void 0, function () {
            return tslib__WEBPACK_IMPORTED_MODULE_0__[/* __generator */ "e"](this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.tempValue = this.v.toFixed(3);
                        this.editMode = true;
                        return [4 /*yield*/, this.$nextTick()];
                    case 1:
                        _a.sent();
                        this.$refs.input.focus();
                        return [2 /*return*/];
                }
            });
        });
    };
    NumberOption.prototype.leaveEditMode = function () {
        this.$emit("input", parseFloat(this.tempValue));
        this.editMode = false;
    };
    tslib__WEBPACK_IMPORTED_MODULE_0__[/* __decorate */ "c"]([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_1__[/* Prop */ "b"])()
    ], NumberOption.prototype, "value", void 0);
    tslib__WEBPACK_IMPORTED_MODULE_0__[/* __decorate */ "c"]([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_1__[/* Prop */ "b"])({ type: String })
    ], NumberOption.prototype, "name", void 0);
    NumberOption = tslib__WEBPACK_IMPORTED_MODULE_0__[/* __decorate */ "c"]([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_1__[/* Component */ "a"])({
            components: {
                "i-arrow": _Arrow_vue__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"]
            }
        })
    ], NumberOption);
    return NumberOption;
}(vue_property_decorator__WEBPACK_IMPORTED_MODULE_1__[/* Vue */ "c"]));
/* harmony default export */ __webpack_exports__["a"] = (NumberOption);


/***/ }),
/* 18 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_ts_loader_index_js_ref_0_node_modules_vue_loader_lib_index_js_vue_loader_options_SelectOption_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(19);
 /* harmony default export */ __webpack_exports__["a"] = (_node_modules_ts_loader_index_js_ref_0_node_modules_vue_loader_lib_index_js_vue_loader_options_SelectOption_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"]); 

/***/ }),
/* 19 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(0);
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1);
/* harmony import */ var _Arrow_vue__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4);
/* harmony import */ var v_click_outside__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(47);
/* harmony import */ var v_click_outside__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(v_click_outside__WEBPACK_IMPORTED_MODULE_3__);



// @ts-ignore

var SelectOption = /** @class */ (function (_super) {
    tslib__WEBPACK_IMPORTED_MODULE_0__[/* __extends */ "d"](SelectOption, _super);
    function SelectOption() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.open = false;
        return _this;
    }
    Object.defineProperty(SelectOption.prototype, "selected", {
        get: function () {
            return this.value ? this.value.selected : "";
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SelectOption.prototype, "items", {
        get: function () {
            return this.value ? this.value.items : [];
        },
        enumerable: true,
        configurable: true
    });
    SelectOption.prototype.setSelected = function (item) {
        this.$emit("input", { selected: item, items: this.items });
    };
    tslib__WEBPACK_IMPORTED_MODULE_0__[/* __decorate */ "c"]([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_1__[/* Prop */ "b"])({ type: String })
    ], SelectOption.prototype, "name", void 0);
    tslib__WEBPACK_IMPORTED_MODULE_0__[/* __decorate */ "c"]([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_1__[/* Prop */ "b"])({ type: Object })
    ], SelectOption.prototype, "value", void 0);
    SelectOption = tslib__WEBPACK_IMPORTED_MODULE_0__[/* __decorate */ "c"]([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_1__[/* Component */ "a"])({
            components: {
                "i-arrow": _Arrow_vue__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"]
            },
            directives: {
                ClickOutside: v_click_outside__WEBPACK_IMPORTED_MODULE_3___default.a.directive
            }
        })
    ], SelectOption);
    return SelectOption;
}(vue_property_decorator__WEBPACK_IMPORTED_MODULE_1__[/* Vue */ "c"]));
/* harmony default export */ __webpack_exports__["a"] = (SelectOption);


/***/ }),
/* 20 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_ts_loader_index_js_ref_0_node_modules_vue_loader_lib_index_js_vue_loader_options_TextOption_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(21);
 /* harmony default export */ __webpack_exports__["a"] = (_node_modules_ts_loader_index_js_ref_0_node_modules_vue_loader_lib_index_js_vue_loader_options_TextOption_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"]); 

/***/ }),
/* 21 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(0);
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1);


var TextOption = /** @class */ (function (_super) {
    tslib__WEBPACK_IMPORTED_MODULE_0__[/* __extends */ "d"](TextOption, _super);
    function TextOption() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(TextOption.prototype, "sanitized", {
        get: function () {
            return String(this.value);
        },
        enumerable: true,
        configurable: true
    });
    tslib__WEBPACK_IMPORTED_MODULE_0__[/* __decorate */ "c"]([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_1__[/* Prop */ "b"])({ default: "" })
    ], TextOption.prototype, "value", void 0);
    TextOption = tslib__WEBPACK_IMPORTED_MODULE_0__[/* __decorate */ "c"]([
        vue_property_decorator__WEBPACK_IMPORTED_MODULE_1__[/* Component */ "a"]
    ], TextOption);
    return TextOption;
}(vue_property_decorator__WEBPACK_IMPORTED_MODULE_1__[/* Vue */ "c"]));
/* harmony default export */ __webpack_exports__["a"] = (TextOption);


/***/ }),
/* 22 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__22__;

/***/ }),
/* 23 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_ButtonOption_vue_vue_type_template_id_6c6f3180___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(32);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_ButtonOption_vue_vue_type_template_id_6c6f3180___WEBPACK_IMPORTED_MODULE_0__["a"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "b", function() { return _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_ButtonOption_vue_vue_type_template_id_6c6f3180___WEBPACK_IMPORTED_MODULE_0__["b"]; });



/***/ }),
/* 24 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_CheckboxOption_vue_vue_type_template_id_0a60a651___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_CheckboxOption_vue_vue_type_template_id_0a60a651___WEBPACK_IMPORTED_MODULE_0__["a"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "b", function() { return _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_CheckboxOption_vue_vue_type_template_id_0a60a651___WEBPACK_IMPORTED_MODULE_0__["b"]; });



/***/ }),
/* 25 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_InputOption_vue_vue_type_template_id_2e1ef5f6___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(36);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_InputOption_vue_vue_type_template_id_2e1ef5f6___WEBPACK_IMPORTED_MODULE_0__["a"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "b", function() { return _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_InputOption_vue_vue_type_template_id_2e1ef5f6___WEBPACK_IMPORTED_MODULE_0__["b"]; });



/***/ }),
/* 26 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_IntegerOption_vue_vue_type_template_id_4eb35aaa___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(38);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_IntegerOption_vue_vue_type_template_id_4eb35aaa___WEBPACK_IMPORTED_MODULE_0__["a"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "b", function() { return _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_IntegerOption_vue_vue_type_template_id_4eb35aaa___WEBPACK_IMPORTED_MODULE_0__["b"]; });



/***/ }),
/* 27 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_Arrow_vue_vue_type_template_id_d85cb940___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(39);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_Arrow_vue_vue_type_template_id_d85cb940___WEBPACK_IMPORTED_MODULE_0__["a"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "b", function() { return _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_Arrow_vue_vue_type_template_id_d85cb940___WEBPACK_IMPORTED_MODULE_0__["b"]; });



/***/ }),
/* 28 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_NumberOption_vue_vue_type_template_id_70fa2a97___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(41);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_NumberOption_vue_vue_type_template_id_70fa2a97___WEBPACK_IMPORTED_MODULE_0__["a"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "b", function() { return _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_NumberOption_vue_vue_type_template_id_70fa2a97___WEBPACK_IMPORTED_MODULE_0__["b"]; });



/***/ }),
/* 29 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_SelectOption_vue_vue_type_template_id_3f2e408a___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(43);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_SelectOption_vue_vue_type_template_id_3f2e408a___WEBPACK_IMPORTED_MODULE_0__["a"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "b", function() { return _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_SelectOption_vue_vue_type_template_id_3f2e408a___WEBPACK_IMPORTED_MODULE_0__["b"]; });



/***/ }),
/* 30 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_TextOption_vue_vue_type_template_id_ee5ee88a___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(45);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_TextOption_vue_vue_type_template_id_ee5ee88a___WEBPACK_IMPORTED_MODULE_0__["a"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "b", function() { return _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_TextOption_vue_vue_type_template_id_ee5ee88a___WEBPACK_IMPORTED_MODULE_0__["b"]; });



/***/ }),
/* 31 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _ButtonOption_vue_vue_type_template_id_6c6f3180___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(23);
/* harmony import */ var _ButtonOption_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6);
/* harmony import */ var _node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2);





/* normalize component */

var component = Object(_node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"])(
  _ButtonOption_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"],
  _ButtonOption_vue_vue_type_template_id_6c6f3180___WEBPACK_IMPORTED_MODULE_0__[/* render */ "a"],
  _ButtonOption_vue_vue_type_template_id_6c6f3180___WEBPACK_IMPORTED_MODULE_0__[/* staticRenderFns */ "b"],
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (false) { var api; }
component.options.__file = "src/ButtonOption.vue"
/* harmony default export */ __webpack_exports__["a"] = (component.exports);

/***/ }),
/* 32 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "button",
    {
      staticClass: "dark-button --block",
      on: {
        click: function($event) {
          return _vm.$emit("openSidebar")
        }
      }
    },
    [_vm._v(_vm._s(_vm.name))]
  )
}
var staticRenderFns = []
render._withStripped = true



/***/ }),
/* 33 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _CheckboxOption_vue_vue_type_template_id_0a60a651___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(24);
/* harmony import */ var _CheckboxOption_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8);
/* harmony import */ var _node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2);





/* normalize component */

var component = Object(_node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"])(
  _CheckboxOption_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"],
  _CheckboxOption_vue_vue_type_template_id_0a60a651___WEBPACK_IMPORTED_MODULE_0__[/* render */ "a"],
  _CheckboxOption_vue_vue_type_template_id_0a60a651___WEBPACK_IMPORTED_MODULE_0__[/* staticRenderFns */ "b"],
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (false) { var api; }
component.options.__file = "src/CheckboxOption.vue"
/* harmony default export */ __webpack_exports__["a"] = (component.exports);

/***/ }),
/* 34 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: { "dark-checkbox": true, "--checked": _vm.value },
      on: {
        click: function($event) {
          return _vm.$emit("input", !_vm.value)
        }
      }
    },
    [
      _c("div", { staticClass: "__checkmark-container" }, [
        _c(
          "svg",
          {
            attrs: {
              xmlns: "http://www.w3.org/2000/svg",
              width: "18",
              height: "18",
              viewBox: "0 0 18 18"
            }
          },
          [
            _c("path", {
              staticClass: "__checkmark",
              attrs: {
                d: "M 6 5 L 6 10 L 16 10",
                transform: "rotate(-45 10 10)"
              }
            })
          ]
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "ml-2" }, [_vm._v(_vm._s(_vm.name))])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true



/***/ }),
/* 35 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _InputOption_vue_vue_type_template_id_2e1ef5f6___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(25);
/* harmony import */ var _InputOption_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(10);
/* harmony import */ var _node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2);





/* normalize component */

var component = Object(_node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"])(
  _InputOption_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"],
  _InputOption_vue_vue_type_template_id_2e1ef5f6___WEBPACK_IMPORTED_MODULE_0__[/* render */ "a"],
  _InputOption_vue_vue_type_template_id_2e1ef5f6___WEBPACK_IMPORTED_MODULE_0__[/* staticRenderFns */ "b"],
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (false) { var api; }
component.options.__file = "src/InputOption.vue"
/* harmony default export */ __webpack_exports__["a"] = (component.exports);

/***/ }),
/* 36 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "input",
      _vm._g(
        {
          staticClass: "dark-input",
          attrs: { type: "text", placeholder: _vm.name },
          domProps: { value: _vm.value }
        },
        _vm.listeners
      )
    )
  ])
}
var staticRenderFns = []
render._withStripped = true



/***/ }),
/* 37 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _IntegerOption_vue_vue_type_template_id_4eb35aaa___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(26);
/* harmony import */ var _IntegerOption_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(12);
/* harmony import */ var _node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2);





/* normalize component */

var component = Object(_node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"])(
  _IntegerOption_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"],
  _IntegerOption_vue_vue_type_template_id_4eb35aaa___WEBPACK_IMPORTED_MODULE_0__[/* render */ "a"],
  _IntegerOption_vue_vue_type_template_id_4eb35aaa___WEBPACK_IMPORTED_MODULE_0__[/* staticRenderFns */ "b"],
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (false) { var api; }
component.options.__file = "src/IntegerOption.vue"
/* harmony default export */ __webpack_exports__["a"] = (component.exports);

/***/ }),
/* 38 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "dark-num-input" }, [
    _c(
      "div",
      { staticClass: "__button --dec", on: { click: _vm.decrement } },
      [_c("i-arrow")],
      1
    ),
    _vm._v(" "),
    !_vm.editMode
      ? _c(
          "div",
          { staticClass: "__content", on: { click: _vm.enterEditMode } },
          [
            _c("div", { staticClass: "__label .text-truncate" }, [
              _vm._v(_vm._s(_vm.name))
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "__value" }, [
              _vm._v(_vm._s(_vm.stringRepresentation))
            ])
          ]
        )
      : _c("div", { staticClass: "__content" }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.tempValue,
                expression: "tempValue"
              }
            ],
            ref: "input",
            attrs: { type: "number" },
            domProps: { value: _vm.tempValue },
            on: {
              blur: _vm.leaveEditMode,
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.tempValue = $event.target.value
              }
            }
          })
        ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "__button --inc", on: { click: _vm.increment } },
      [_c("i-arrow")],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true



/***/ }),
/* 39 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24"
      }
    },
    [
      _c("path", {
        attrs: { d: "M7.41 8.59L12 13.17l4.59-4.58L18 10l-6 6-6-6 1.41-1.41z" }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true



/***/ }),
/* 40 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _NumberOption_vue_vue_type_template_id_70fa2a97___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(28);
/* harmony import */ var _NumberOption_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(16);
/* harmony import */ var _node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2);





/* normalize component */

var component = Object(_node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"])(
  _NumberOption_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"],
  _NumberOption_vue_vue_type_template_id_70fa2a97___WEBPACK_IMPORTED_MODULE_0__[/* render */ "a"],
  _NumberOption_vue_vue_type_template_id_70fa2a97___WEBPACK_IMPORTED_MODULE_0__[/* staticRenderFns */ "b"],
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (false) { var api; }
component.options.__file = "src/NumberOption.vue"
/* harmony default export */ __webpack_exports__["a"] = (component.exports);

/***/ }),
/* 41 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "dark-num-input" }, [
    _c(
      "div",
      { staticClass: "__button --dec", on: { click: _vm.decrement } },
      [_c("i-arrow")],
      1
    ),
    _vm._v(" "),
    !_vm.editMode
      ? _c(
          "div",
          { staticClass: "__content", on: { click: _vm.enterEditMode } },
          [
            _c("div", { staticClass: "__label .text-truncate" }, [
              _vm._v(_vm._s(_vm.name))
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "__value" }, [
              _vm._v(_vm._s(_vm.stringRepresentation))
            ])
          ]
        )
      : _c("div", { staticClass: "__content" }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.tempValue,
                expression: "tempValue"
              }
            ],
            ref: "input",
            attrs: { type: "number" },
            domProps: { value: _vm.tempValue },
            on: {
              blur: _vm.leaveEditMode,
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.tempValue = $event.target.value
              }
            }
          })
        ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "__button --inc", on: { click: _vm.increment } },
      [_c("i-arrow")],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true



/***/ }),
/* 42 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _SelectOption_vue_vue_type_template_id_3f2e408a___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(29);
/* harmony import */ var _SelectOption_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(18);
/* harmony import */ var _node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2);





/* normalize component */

var component = Object(_node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"])(
  _SelectOption_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"],
  _SelectOption_vue_vue_type_template_id_3f2e408a___WEBPACK_IMPORTED_MODULE_0__[/* render */ "a"],
  _SelectOption_vue_vue_type_template_id_3f2e408a___WEBPACK_IMPORTED_MODULE_0__[/* staticRenderFns */ "b"],
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (false) { var api; }
component.options.__file = "src/SelectOption.vue"
/* harmony default export */ __webpack_exports__["a"] = (component.exports);

/***/ }),
/* 43 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "click-outside",
          rawName: "v-click-outside",
          value: function() {
            _vm.open = false
          },
          expression: "() => { open = false; }"
        }
      ],
      class: ["dark-select", { "--open": _vm.open }],
      on: {
        click: function($event) {
          _vm.open = !_vm.open
        }
      }
    },
    [
      _c("div", { staticClass: "__selected" }, [
        _c("div", { staticClass: "__text" }, [_vm._v(_vm._s(_vm.selected))]),
        _vm._v(" "),
        _c("div", { staticClass: "__icon" }, [_c("i-arrow")], 1)
      ]),
      _vm._v(" "),
      _c("transition", { attrs: { name: "slide-fade" } }, [
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.open,
                expression: "open"
              }
            ],
            staticClass: "__dropdown"
          },
          [
            _c("div", { staticClass: "item --header" }, [
              _vm._v(_vm._s(_vm.name))
            ]),
            _vm._v(" "),
            _vm._l(_vm.items, function(item) {
              return _c(
                "div",
                {
                  key: item,
                  class: ["item", { "--active": _vm.selected === item }],
                  on: {
                    click: function($event) {
                      return _vm.setSelected(item)
                    }
                  }
                },
                [_vm._v(_vm._s(item))]
              )
            })
          ],
          2
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true



/***/ }),
/* 44 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _TextOption_vue_vue_type_template_id_ee5ee88a___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(30);
/* harmony import */ var _TextOption_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(20);
/* harmony import */ var _node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2);





/* normalize component */

var component = Object(_node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"])(
  _TextOption_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"],
  _TextOption_vue_vue_type_template_id_ee5ee88a___WEBPACK_IMPORTED_MODULE_0__[/* render */ "a"],
  _TextOption_vue_vue_type_template_id_ee5ee88a___WEBPACK_IMPORTED_MODULE_0__[/* staticRenderFns */ "b"],
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (false) { var api; }
component.options.__file = "src/TextOption.vue"
/* harmony default export */ __webpack_exports__["a"] = (component.exports);

/***/ }),
/* 45 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [_vm._v(_vm._s(_vm.sanitized))])
}
var staticRenderFns = []
render._withStripped = true



/***/ }),
/* 46 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return OptionPlugin; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(0);
/* harmony import */ var _options__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5);


var OptionPlugin = /** @class */ (function () {
    function OptionPlugin() {
        this.type = "OptionPlugin";
    }
    OptionPlugin.prototype.register = function (editor) {
        var _this = this;
        editor.events.usePlugin.addListener(this, function (p) {
            if (p.type === "ViewPlugin") {
                _this.registerOptions(p);
            }
        });
        editor.plugins.forEach(function (p) {
            if (p.type === "ViewPlugin") {
                _this.registerOptions(p);
            }
        });
    };
    OptionPlugin.prototype.registerOptions = function (viewPlugin) {
        Object.entries(_options__WEBPACK_IMPORTED_MODULE_1__).forEach(function (_a) {
            var _b = tslib__WEBPACK_IMPORTED_MODULE_0__[/* __read */ "f"](_a, 2), k = _b[0], v = _b[1];
            viewPlugin.registerOption(k, v);
        });
    };
    return OptionPlugin;
}());



/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,n){ true?module.exports=n():undefined}(this,function(){var e="undefined"!=typeof window&&("ontouchstart"in window||navigator.msMaxTouchPoints>0)?["touchstart","click"]:["click"],n=[];function t(n){var t="function"==typeof n;if(!t&&"object"!=typeof n)throw new Error("v-click-outside: Binding value must be a function or an object");return{handler:t?n:n.handler,middleware:n.middleware||function(e){return e},events:n.events||e}}function r(e){var n=e.el,t=e.event,r=e.handler,i=e.middleware;t.target!==n&&!n.contains(t.target)&&i(t,n)&&r(t,n)}var i={bind:function(e,i){var d=t(i.value),o=d.handler,a=d.middleware,u={el:e,eventHandlers:d.events.map(function(n){return{event:n,handler:function(n){return r({event:n,el:e,handler:o,middleware:a})}}})};u.eventHandlers.forEach(function(e){return document.addEventListener(e.event,e.handler)}),n.push(u)},update:function(e,i){var d=t(i.value),o=d.handler,a=d.middleware,u=d.events,c=n.find(function(n){return n.el===e});c.eventHandlers.forEach(function(e){return document.removeEventListener(e.event,e.handler)}),c.eventHandlers=u.map(function(n){return{event:n,handler:function(n){return r({event:n,el:e,handler:o,middleware:a})}}}),c.eventHandlers.forEach(function(e){return document.addEventListener(e.event,e.handler)})},unbind:function(e){n.find(function(n){return n.el===e}).eventHandlers.forEach(function(e){return document.removeEventListener(e.event,e.handler)})},instances:n};return{install:function(e){e.directive("click-outside",i)},directive:i}});
//# sourceMappingURL=v-click-outside.min.min.umd.js.map


/***/ }),
/* 48 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _options__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ButtonOption", function() { return _options__WEBPACK_IMPORTED_MODULE_0__["ButtonOption"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "CheckboxOption", function() { return _options__WEBPACK_IMPORTED_MODULE_0__["CheckboxOption"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "InputOption", function() { return _options__WEBPACK_IMPORTED_MODULE_0__["InputOption"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "IntegerOption", function() { return _options__WEBPACK_IMPORTED_MODULE_0__["IntegerOption"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "NumberOption", function() { return _options__WEBPACK_IMPORTED_MODULE_0__["NumberOption"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SelectOption", function() { return _options__WEBPACK_IMPORTED_MODULE_0__["SelectOption"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "TextOption", function() { return _options__WEBPACK_IMPORTED_MODULE_0__["TextOption"]; });

/* harmony import */ var _optionPlugin__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(46);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "OptionPlugin", function() { return _optionPlugin__WEBPACK_IMPORTED_MODULE_1__["a"]; });





/***/ })
/******/ ]);
});